import { Center, Flex, useMantineTheme, Image } from "@mantine/core";
import { Logo, TextHTML } from "../../../../components";
import { client_selected } from "../../../../client";
import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";
import { useAuth } from "../../../../context/auth";
import { useLocation, useNavigate } from "react-router-dom";

export default function LayoutInfoAuthGenial() {
  const theme = useMantineTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { signInWithToken, isAuthenticated, isInMaintenance } = useAuth();
  const location = useLocation();
  const hash = window.location.hash;
  const tokenRef = useRef(
    location.search.split("?token=")[1]
      || (hash ? hash.replace('#token=', '') : null)
  );
  const genialToken = tokenRef.current;

  useEffect(() => {
    if (genialToken) {
      if (window.location.hash) {
        window.history.replaceState(null, '', window.location.pathname);
      }
      signInWithToken({ token: genialToken, route: "predix" });
    }
  }, [genialToken]);

  return (
    <Center px={{ base: 24, 991: 100, 1300: 200 }} w="100%">
      <Flex
        w="100%"
        maw={800}
        bg="basic.0"
        align="center"
        justify="center"
        direction={{ base: "column" }}
        gap={80}
        style={{
          boxShadow: "0px 10px 40px rgba(0, 0, 0, 0.1)",
          borderRadius: "20px",
          overflow: "hidden",
        }}
        p={{ base: "32px 16px", 991: "80px 80px", 1600: "80px 142px" }}
      >
        <Flex direction="column" gap={48} align="center" justify="center">
          <Flex direction="column" gap={16} align="center" justify="center">
            <Image src={client_selected.image.logo2} alt="Logo" fit="contain" />

            <TextHTML
              maw="1138px"
              fz={{ base: 16, 991: 24 }}
              lh={{ base: "32px", 991: "40px" }}
              data-aos={"fade-top"}
              color={theme.colors.basic[5]}
              ta="center"
              textHTML={t("autenticacao.genial_login.description")}
            />
          </Flex>
        </Flex>
      </Flex>
    </Center>
  );
}
